// import axios from "axios";
import apiManagement from "../config/api_management";
import getHeaders from "./getHeaders";

// const apiManagement = axios.create({
//   baseURL: "http://localhost:8081",
// });

export function findAll(payload) {
  const {
    groupId,
    farmId,
    page = 0,
    size = 10,
    sort = "id",
    direction = "ASC",
    search,
  } = payload;
  const params = new URLSearchParams({ page, size, sort, direction });
  if (search) params.append("search", search);
  return apiManagement.get(
    `/bovexo/${groupId}/farms/${farmId}/items-groups?${params.toString()}`,
    getHeaders(false, null),
  );
}

export function findAllGroupItems(payload) {
  const { groupId, farmId } = payload;
  return apiManagement.get(
    `/bovexo/${groupId}/farms/${farmId}/group-items?withoutPagination=true`,
    getHeaders(false, null),
  );
}

export function save(payload) {
  const { groupId, farmId, id, body } = payload;
  if (id == null) {
    return apiManagement.post(
      `/bovexo/${groupId}/farms/${farmId}/items-groups`,
      body,
      getHeaders(false, null),
    );
  }
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/${farmId}/items-groups/${id}`,
    body,
    getHeaders(false, null),
  );
}

export function saveForGroup(payload) {
  const { groupId, id, body } = payload;
  if (id == null) {
    return apiManagement.post(
      `/bovexo/${groupId}/farms/items-groups`,
      body,
      getHeaders(false, null),
    );
  }
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/items-groups/${id}`,
    body,
    getHeaders(false, null),
  );
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;
  return apiManagement.delete(
    `/bovexo/${groupId}/farms/${farmId}/items-groups/${id}`,
    getHeaders(false, null),
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/${farmId}/items-groups/${id}/active`,
    null,
    getHeaders(false, null),
  );
}

export function classify(payload) {
  const { groupId, farmId, id, classification } = payload;
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/${farmId}/items-groups/${id}/classify`,
    { classification },
    getHeaders(false, null),
  );
}
